import * as tslib_1 from "tslib";
import { groupBy, keyBy } from 'lodash';
import moment from 'moment';
import * as i0 from "@angular/core";
var DashboardStorageMovementsMapperService = /** @class */ (function () {
    function DashboardStorageMovementsMapperService() {
    }
    DashboardStorageMovementsMapperService.prototype.toLineChartFormat = function (_a) {
        var e_1, _b;
        var movementsByDay = _a.movementsByDay, from = _a.from, to = _a.to;
        var grouped = groupBy(movementsByDay, 'storageName');
        var result = [];
        try {
            for (var _c = tslib_1.__values(Object.keys(grouped)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var group = _d.value;
                var movements = grouped[group];
                var map = keyBy(movements, 'date');
                var items = [];
                var date = moment(from);
                while (date.isSameOrBefore(to, 'day')) {
                    var dateKey = date.format('YYYY-MM-DD');
                    var item = map[dateKey];
                    items.push(this.createChartItem(date, item, items));
                    date.add(1, 'day');
                }
                result.push({
                    name: group,
                    series: items
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    DashboardStorageMovementsMapperService.prototype.createChartItem = function (date, item, items) {
        var dateKey = date.format('DD/MM');
        var formattedDate = date.format('DD/MM/YYYY');
        var formattedName = item && item.storageName ? item.storageName + " \u2022 " + formattedDate : formattedDate;
        if (item) {
            return {
                name: dateKey,
                formattedName: formattedName,
                value: item.finalCount,
                item: item
            };
        }
        var previousItem = items[items.length - 1];
        if (previousItem) {
            var storageName = previousItem.item ? previousItem.item.storageName : '';
            return {
                name: dateKey,
                formattedName: storageName + " \u2022 " + formattedDate,
                value: previousItem.value,
                item: previousItem.item
            };
        }
        return {
            name: dateKey,
            formattedName: formattedName,
            value: 0,
            item: null
        };
    };
    DashboardStorageMovementsMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardStorageMovementsMapperService_Factory() { return new DashboardStorageMovementsMapperService(); }, token: DashboardStorageMovementsMapperService, providedIn: "root" });
    return DashboardStorageMovementsMapperService;
}());
export { DashboardStorageMovementsMapperService };
